import { api, apiNet } from '@cems-eco/core/src/services/api';

export abstract class BaseAuthApi {
    private BASE_URL: string;

    constructor() {
        this.BASE_URL = "/auth/login";
    }

    async social(): Promise<any> {
        return await api.get<any>("/auth/social");
    }

    async login(data: any): Promise<any> {
        return await api.post<any>(this.BASE_URL, data);
    }

    async getSite(): Promise<any> {
        const params = {
            scope: "siteBox",
            "no-paginate": true
        }
        return await api.get<any>("/client", params);
    }

    async site(id): Promise<any> {
        return await api.post<any>("/auth/site", { id });
    }

    async autoLogin(platform, token: string): Promise<any> {
        return await api.post<any>(`/auth/${platform}/auto-login`, { token });
    }

    abstract getUrl(endpoint: string, hash: string);
    abstract healthcheck(hash: string);
}
